import { isLoadingType } from '../loading/selectors';
import { LOAD_PROFILES_REQUEST, LOAD_PROFILE_REQUEST, SET_PROFILE_AVATAR_ALIAS_REQUEST, SET_PROFILE_AVATAR_DESCRIPTION_REQUEST } from './actions';
const isFetchProfileAction = (action) => action.type === LOAD_PROFILE_REQUEST;
const isFetchProfilesAction = (action) => action.type === LOAD_PROFILES_REQUEST;
export const getState = state => state.profile;
export const getData = state => getState(state).data;
export const getError = state => getState(state).error;
export const getLoading = (state) => getState(state).loading;
export const getProfileOfAddress = (state, address) => getData(state)[address];
export const getProfileOfAddresses = (state, addresses) => addresses
    .map(address => getProfileOfAddress(state, address))
    .filter(Boolean);
export const isLoadingSetProfileAvatarDescription = (state) => isLoadingType(getLoading(state), SET_PROFILE_AVATAR_DESCRIPTION_REQUEST);
export const isLoadingSetProfileAvatarAlias = (state) => isLoadingType(getLoading(state), SET_PROFILE_AVATAR_ALIAS_REQUEST);
export const getProfileError = (state) => getState(state).error;
export const getProfilesBeingLoaded = (state) => {
    return [
        ...getLoading(state)
            .filter(isFetchProfileAction)
            .map(action => action.payload.address),
        ...getLoading(state)
            .filter(isFetchProfilesAction)
            .flatMap(action => action.payload.addresses)
    ];
};
export const isLoadingProfile = (state, address) => getProfilesBeingLoaded(state).includes(address.toLowerCase());
export const isLoadingSomeProfiles = (state, addresses) => getProfilesBeingLoaded(state).some(address => addresses.includes(address));
export const isLoadingAllProfiles = (state, addresses) => {
    const profilesBeingLoaded = getProfilesBeingLoaded(state);
    return addresses.every(address => profilesBeingLoaded.includes(address.toLowerCase()));
};
//# sourceMappingURL=selectors.js.map